import blog1 from "../assets/images/home/blogposts/b1.png";
import blog2 from "../assets/images/home/blogposts/b2.png";
import blog3 from "../assets/images/home/blogposts/b3.png";

export const blogPosts = [
  {
    id: "1",
    title: "How to Choose the Right Gypsum Board",
    desc: "Every high-quality wall starts long before installation, it starts with the board you choose.",
    date: "25 Jan 2026",
    image: blog1,
    caption: "Image caption: IRQGYP production",
  },
  {
    id: "2",
    title: "Standard vs. Moisture-Resistant vs. Fire-Resistant Boards",
    desc: "Not all gypsum boards are born equal. Each formulation serves a distinct purpose.",
    date: "25 Jan 2026",
    image: blog2,
    caption: "Image caption: Product comparison showcase",
  },
  {
    id: "3",
    title: "Understanding Board Thickness",
    desc: "Gypsum board thickness is more than a dimension; it governs flexibility, strength, sound.",
    date: "25 Jan 2026",
    image: blog3,
    caption: "Image caption: Board profile and details",
  },
];

